export default __webpack_public_path__ + "static/media/v02.9c09cbf7.png";